<template>
  <v-card class="hvh-card--rounded hvh-input-summary">
    <v-card-title class="hvh-input-summary__header px-4">
      <div class="hvh-input-summary__title">
        <slot name="title" />
      </div>
      <div class="hvh-input-summary__actions">
        <slot name="actions" />
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text class="px-4 hvh-input-summary__items">
      <div class="hvh-input-summary__item mb-4" v-for="item in items" :key="item.label">
        <h3 class="hvh-h6 hvh-input-summary__item__label" v-if="!item.hideLabel">
          {{ item.label }}
        </h3>
        <template v-for="group in item.groups">
          <div class="pl-3 hvh-input-summary__item__group__condition" v-if="group.condition" :key="'condition-' + group.key">
            {{ group.condition }}
          </div>
          <div class="hvh-input-summary__item__group pa-2 my-3" :key="group.key">
            <span class="px-2 hvh-input-summary__item__group__empty" v-if="!group.fields || !group.fields.length"> None </span>
            <div v-for="field in group.fields" :class="'hvh-input-summary__item__group__field ' + getFieldModifiers(field)" :key="field.label">
              <label class="hvh-input-summary__item__group__field__label" v-if="field.showLabel" :id="'label-for-' + field.label">
                {{ field.label }}
              </label>
              <div class="hvh-input-summary__item__group__field__value" v-for="value in field.values" :aria-labelledby="'label-for-' + field.label" :key="value.label">
                <span class="ml-4 hvh-input-summary__item__group__field__value__condition" v-if="value.condition">
                  <v-icon color="primary" small>mdi-subdirectory-arrow-right</v-icon>
                  <span>{{ value.condition }}</span>
                </span>
                <a :href="value.url || value.link">
                  <DPDPill class="pill" :type="value.type" :label="value.label" />
                </a>
                <span class="hvh-input-summary__item__group__field__value__note" v-if="value.note">{{ value.note }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import DPDPill from '../../analytics/cohorts/DPDPill.vue';
export default {
  components: { DPDPill },
  props: ['items'],
  methods: {
    getFieldModifiers(field) {
      if (field.inline) {
        return 'hvh-input-summary__item__group__field--inline';
      }
      return '';
    }
  }
}
</script>

<style lang="scss">
.hvh-input-summary__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.hvh-input-summary__items {
  max-width: 800px;
}

.hvh-input-summary__item__label {
  color: $color-text-default;
}

.hvh-input-summary__item__group {
  border: 1px solid $color-gray-1;
  border-radius: 6px;
}

.hvh-input-summary__item__group__empty {
  font-size: rem(16px);
  font-weight: 600;
}

.hvh-input-summary__item__group__condition {
  color: $color-brand-primary;
  font-size: rem(15px);
  font-weight: 600;
  letter-spacing: 1.1px;
  text-transform: uppercase;
}

.hvh-input-summary__item__group__field--inline {
  align-items: center;
  display: flex;

  .hvh-input-summary__item__group__field__label {
    flex: 0 0 100px;
    margin-right: rem(8px);
    text-align: right;
  }
}

.hvh-input-summary__item__group__field__label {
  font-size: rem(16px);
  font-weight: 600;

  &::after {
    content: ':';
    margin-left: rem(-3px);
  }
}

.hvh-input-summary__item__group__field__value {
  align-items: center;
  display: flex;

  .v-chip {
    background: $color-gray-1;
  }

  .v-chip__content {
    font-size: rem(16px);
    font-weight: bold;
  }
}

.hvh-input-summary__item__group__field__value__condition {
  align-items: center;
  color: $color-brand-primary;
  display: flex;
  font-size: rem(16px);
  font-weight: 600;
  margin-right: rem(3px);
  text-transform: uppercase;
}

.hvh-input-summary__item__group__field__value__note {
  color: $color-text-light;
  font-size: rem(11px);
  margin-left: rem(3px);
}

.v-chip__content.clickable {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);
}
</style>
